import { Outlet } from '@tanstack/react-router';

import { useThemeSync } from '@rootsight/ui';

/** Root applies the operator's saved theme to every page of this SPA. */
export function Root() {
  useThemeSync();
  return <Outlet />;
}
